export default {"src":"/_next/static/media/graph_bars.bffa62a2.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};